module.exports = __webpack_public_path__ + "media/images/country_flags/tv-336f789ca96b278a25e3cef2587fc2a7.png";